import Middleware from './Middleware';

export default Middleware;
